<script lang="ts" setup>
withDefaults(
  defineProps<{
    initials: string;
    size?: number;
    inverted?: boolean;
  }>(),
  {
    size: 36,
    inverted: false
  }
);
</script>

<template>
  <span
    class="ds-avatar"
    :class="{ 'ds-avatar--inverted': inverted }"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
      fontSize: `${Math.max(11, size * 0.32)}px`
    }"
  >
    {{ initials }}
  </span>
</template>

<style lang="scss" scoped>
.ds-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  background: $primary;
  color: $primary-invert;
  font-weight: 600;
  line-height: 1;
}

.ds-avatar--inverted {
  background: $white;
  color: $primary;
}
</style>
